import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import moment from 'moment-timezone';
let RoombaCalendarPermissions = (_class = class RoombaCalendarPermissions extends Component {
  get lastCheckedAt() {
    const timestamp = this.args.room.calendarPermissionsStatus?.permissionsLastCheckedAt;
    return timestamp ? moment(timestamp).format('h:mm a z on MMMM D, YYYY') : undefined;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "graphql", _descriptor2, this);
    _defineProperty(this, "recheckTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          yield this.graphql.checkCalendarPermissions({
            roomId: this.args.room.id
          });
        } catch (e) {
          this.flashMessages.showFlash('error', 'Error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "recheckTask", null));
    const room = this.args.room;
    if (room.calendarPermissionsStatus?.permissionsLastCheckedAt === null) {
      void this.recheckTask.perform();
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { RoombaCalendarPermissions as default };